module.exports = require("net");


//////////////////
// WEBPACK FOOTER
// external "net"
// module id = 111
// module chunks = 0 1 2 3